const initState = {
  retentionPropertyParams: {},
  retention_book_show: "",
  retentionDatas: {},
  cacheRequest: null,
  retentModel: 'extant'
};

const retentionAnalysis = {
  state: initState,
  mutations: {
    SET_USER_RETENTION_PROPERTY_PARAMS(state, param) {
      state.retentionPropertyParams = param;
    },
    SET_RETENTION_BOOK_SHOW(state, url) {
      state.retention_book_show = url;
    },
    SET_RETENTION_DATAS(state, url) {
      state.retentionDatas = url;
    },
    SET_CACHE_REQUEST(state, obj) {
      state.cacheRequest = obj;
    },
    SET_RETEN_TMODEL(state, val) {
      state.retentModel = val;
    }
  },
  getters: {},
  actions: {}
};

export default retentionAnalysis;



// WEBPACK FOOTER //
// ./src/store/modules/retention-analysis.js